import React, { useCallback, useState } from 'react';
import { ATMButton, ATMModal } from 'shared-it-appmod-ui';
import {
  ToastError,
  ToastSuccess,
} from 'src/components/atoms/toaster/toaster.component';
import { useFireAgencyContext } from 'src/contexts/fire-agency.context';
import { IFireAgency } from 'src/models/fire-agency.model';
import Lang from 'src/libraries/language';
import { getFireAgencyStatus } from 'src/selectors/fire-agency.selector';
import { actionTypes } from 'src/ducks/fire-agency.duck';
import style from '../fire-agencies-list/fire-agencies-list.module.scss';

type IProp = {
  data: IFireAgency;
};

const FireAgenciesDelete: React.FC<IProp> = ({ data }) => {
  const { state, actions } = useFireAgencyContext();
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);

  const deleteStatus = getFireAgencyStatus(
    state,
    actionTypes.FIRE_AGENCY_DELETE
  );

  const handleDelete = useCallback(async () => {
    if (data.agencyId) {
      const response = await actions.itemDELETE(data.agencyId);

      if (!response.error) {
        setIsDeleteOpen(false);
        actions.listGET();

        ToastSuccess(
          Lang.formatString(Lang.MSG_FIRE_AGENCY_DELETE_SUCCESS, data.name)
        );
      } else {
        ToastError(response.error.message);
      }
    }
  }, [actions, data]);

  return (
    <ATMModal
      open={isDeleteOpen}
      size="tiny"
      trigger={
        <ATMButton
          className={style.actionIcon}
          basic
          icon="trash alternate outline"
          onClick={() => setIsDeleteOpen(true)}
        />
      }
      header={Lang.LBL_DELETE_FIRE_AGENCY}
      content={
        <div className={style.content}>
          {Lang.formatString(Lang.MSG_CONFIRM_DELETE, data.name)}
        </div>
      }
      actions={
        <div className={style.actionBtns}>
          <ATMButton
            basic
            color="blue"
            content={Lang.LBL_CANCEL}
            onClick={() => setIsDeleteOpen(false)}
          />
          <ATMButton
            negative
            content={Lang.LBL_YES_DELETE}
            onClick={handleDelete}
            disabled={deleteStatus.fetching}
            loading={deleteStatus.fetching}
          />
        </div>
      }
    />
  );
};

export default FireAgenciesDelete;
